<template>
  <div class="current-creations-row">
    <div v-for="n in slotLimit" v-bind:class="n % 2 ? (slotLimit === 1 ? 'terminal-left-single' : 'terminal-left') : 'terminal-right'">
      <div v-if="slotLimit > 1" v-bind:class="n % 2 ? 'slot-number-left' : 'slot-number-right'"><span>{{n}}</span></div>
      <div v-bind:class="n % 2 ? 'terminal-monitor-left' : 'terminal-monitor-right'" v-bind:id="'terminal-' + n" v-on:dragover="dragOver" v-on:dragenter="dragEnter" v-on:dragleave="dragLeave" v-on:drop="drop" v-bind:style="(terminalMediaArr.length > 0 && terminalMediaArr[n - 1] && terminalMediaArr[n - 1].media_content && terminalMediaArr[n - 1].media_content.message) ? { backgroundImage: 'url(' + terminalMediaArr[n - 1].media_content.message + ')', backgroundSize: 'cover' } : { background: 'none' }" :data-diffusion-index="(n - 1)" :terminal-data-media-id="(terminalMediaArr.length > 0 && terminalMediaArr[n - 1] && terminalMediaArr[n - 1].media_content && terminalMediaArr[n - 1].media_content.message) ? terminalMediaArr[n - 1].media_id : 'false'" v-on:mouseenter="contextMenu" v-on:mouseleave="closeContextMenu">
        <!-- start (full slot tooltip) -->
        <div v-if="terminalMediaArr[n - 1]" v-bind:id="'tooltip-' + n" v-bind:class="n % 2 ? 'bmtv-tooltip top bmtv-tooltip-left' : 'bmtv-tooltip top bmtv-tooltip-right'" v-bind:style=" tootipId === ('tooltip-' + n) ? { top: '-115px' } : { top: '-1000px' }">
          <div class="bmtv-tooltip-arrow"></div>
          <div class="bmtv-tooltip-inner">
            <div class="bmtv-tooltip-inner-item" :data-media-id="terminalMediaArr[n - 1].media_id" v-on:click="zoom">
              Zoomer
              <div class="glyphicon glyphicon-zoom-in context-ico"></div>
            </div>
            <div class="bmtv-tooltip-inner-item" :data-media-id="terminalMediaArr[n - 1].media_id" v-on:click="reuse">
              Réutiliser
              <div class="glyphicon glyphicon-retweet context-ico"></div>
            </div>
            <div class="bmtv-tooltip-inner-item" :data-media-id="terminalMediaArr[n - 1].media_id" v-on:click="stop">
              Ne plus diffuser
              <div class="glyphicon glyphicon-log-out context-ico"></div>
            </div>
            <div class="bmtv-tooltip-inner-item" :data-media-id="terminalMediaArr[n - 1].media_id" v-on:click="suppress">
              <input type="hidden" id="mediaIdSuppression" name="mediaIdSuppression" :value="terminalMediaArr[n - 1].media_id"/>
              Supprimer
              <div class="glyphicon glyphicon-trash context-ico"></div>
            </div>
          </div>
        </div>
        <!-- end (full slot tooltip) -->
      </div>
    </div>
    </div>
  </div>
</template>
<script>
  // slot-limit medias edit
  const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)
  export default {
    props: ['slotLimit', 'editEnabled', 'userProps', 'overDropZone', 'terminalMediaArr', 'currentDraggedImg'],
    //
    data () {
      return {
        user: AppModules.getUser(),
        originalImg: 'none',
        tootipId: null,
        definitions: AppModules.MessageDefinitions[process.env.APP_NAME]
      }
    },
    //
    components: {},
    mounted: function () {},
    methods: {
      switchDiffusionIndex: function (e, Callback) {
        if (
            this.$parent.userProps &&
            this.$parent.userProps.appData &&
            this.$parent.userProps.appData.medias &&
            this.$parent.userProps.appData.medias.length > 0 &&
            this.$parent.overDropZone
          ) {
          let mediaIdText = e.dataTransfer.getData('text/plain')
          let mediaId = parseInt(mediaIdText.split('-')[1])
          //
          this.$parent.userProps.appData.medias.forEach(function (item) {
            if (
                item.media_content &&
                (item.media_content.diffusionIndex || typeof item.media_content.diffusionIndex === 'number') &&
                (parseInt(item.media_content.diffusionIndex) === parseInt(e.target.dataset.diffusionIndex))
              ) {
              delete item.media_content.diffusionIndex
            }
            if (item.media_id === mediaId) {
              item.media_content.diffusionIndex = parseInt(e.target.dataset.diffusionIndex)
            }
          })
          return Callback(null, true)
        }
      },
      stop: function (e) {
        let mediaId = e.target.dataset.mediaId
        let currentMedia = this.$parent.getMedia(mediaId)
        if (currentMedia && currentMedia.media_content && typeof currentMedia.media_content.diffusionIndex === 'number') {
          delete currentMedia.media_content.diffusionIndex
          console.log(`currentMedia-2 ${JSON.stringify(currentMedia, null, 4)}`)
        }
        //
        return this.$parent.findTerminalMedia(this.$parent.userProps.appData.medias, err => {
          if (err) {
            console.error(err)
          }
          return this.$nextTick().then(() => {
            this.$parent.offsetStrip(this.$parent.userProps.appData.medias)
            document.querySelector('#validModalContent').textContent = 'La diffusion de votre message va s\'arrêter.'
            return this.$parent.saveMessages(false)
          })
        })
      },
      suppress: function (e) {
        let mediaId = e.target.dataset.mediaId
        let currentMedia = this.$parent.getMedia(mediaId)
        console.log(`currentMedia-1 ${JSON.stringify(currentMedia, null, 4)}`)
        //
        if (currentMedia && typeof currentMedia.media_id === 'number') {
          if (currentMedia && currentMedia.media_content && typeof currentMedia.media_content.diffusionIndex === 'number') {
            delete currentMedia.media_content.diffusionIndex
          }
          return this.$parent.confirmMessageSuppression(currentMedia)
        }
      },
      dragOver: function (e) {
        e.preventDefault()
      },
      dragEnter: function (e) {
        this.$parent.overDropZone = true
        e.target.style.opacity = 0.7
        this.originalImg = (e.target.style.backgroundImage) ? e.target.style.backgroundImage : 'none'
        e.target.style.backgroundImage = 'url(' + this.$parent.currentDraggedImg + ')'
      },
      dragLeave: function (e) {
        e.target.style.opacity = 1
        this.$parent.overDropZone = false
        e.target.style.backgroundImage = this.originalImg
      },
      drop: function (e) {
        e.preventDefault()
        e.target.style.opacity = 1
        // console.log(`1 /////////////////////// ${JSON.stringify(this.$parent.userProps.appData.medias, null, 4)}`)
        return this.switchDiffusionIndex(e, (err, success) => {
          if (err) {
            console.error(err)
          }
          this.$parent.switchWelcomeMessage(true)
          // this.$parent.offsetStrip(this.$parent.userProps.appData.medias)
          document.querySelector('#validModalContent').textContent = 'Votre message est enregistré pour diffusion.'
          return this.$parent.saveMessages(false)
        })
      },
      contextMenu: function (e) {
        e.preventDefault()
        if (this.$parent.editEnabled) {
          let contextMenuId = 'tooltip-' + parseInt(e.target.id.split('-')[1])
          this.tootipId = contextMenuId
          console.log('///////////////////////////////////\n-this.tootipId: ' + this.tootipId)
        }
      },
      closeContextMenu: function (e) {
        if (this.$parent.editEnabled) {
          e.preventDefault()
          this.tootipId = null
        }
      },
      zoom: function (e) {
        let mediaId = e.target.dataset.mediaId
        let currentMedia = this.$parent.getMedia(mediaId)
        //
        let target = document.querySelector('#app')
        let backdrop = document.createElement('DIV')
        let messageMediaImg = document.createElement('IMG')
        backdrop.setAttribute('id', 'backdrop')
        messageMediaImg.setAttribute('id', 'message-media-img')
        target.style.zIndex = '200'
        target.style.position = 'fixed'
        target.appendChild(backdrop)
        target.appendChild(messageMediaImg)
        let elementBackdrop = document.querySelector('#backdrop')
        let elementMessageMediaImg = document.querySelector('#message-media-img')
        //
        elementBackdrop.style.backgroundColor = 'var(--grey-seventh-color)'
        elementBackdrop.style.width = '100%'
        elementBackdrop.style.height = '100%'
        elementBackdrop.style.position = 'fixed'
        elementBackdrop.style.top = '0'
        elementBackdrop.style.left = '0'
        elementBackdrop.style.zIndex = '1999999998'
        elementBackdrop.style.opacity = '0.5'
        //
        elementMessageMediaImg.style.width = 'calc(100vh / (1080 / 1024))'
        elementMessageMediaImg.style.position = 'fixed'
        elementMessageMediaImg.style.top = 'calc((100vh / 2) - ((100vh / (1080 / 668)) / 2)'
        elementMessageMediaImg.style.left = 'calc((100vw / 2) - ((100vh / (1080 / 1024)) / 2)'
        elementMessageMediaImg.style.zIndex = '1999999999'
        elementMessageMediaImg.style.opacity = '1'
        elementMessageMediaImg.src = currentMedia.media_content.message
        //
        let closeImg = document.createElement('span')
        closeImg.setAttribute('id', 'closeImg')
        elementBackdrop.appendChild(closeImg)
        document.getElementById('closeImg').innerHTML = 'x'
        closeImg.style.marginTop = '15px'
        closeImg.style.marginRight = '15px'
        closeImg.style.float = 'right'
        closeImg.style.cursor = 'pointer'
        closeImg.style.fontWeight = 'bold'
        closeImg.style.fontSize = '25px'
        closeImg.style.color = 'var(--grey-third-color)'
        closeImg.style.lineHeight = '27px'
        closeImg.style.width = '35px'
        closeImg.style.height = '35px'
        closeImg.style.border = '3px solid'
        closeImg.style.borderRadius = '50%'
        closeImg.style.verticalAlign = 'middle'
        //
        elementBackdrop.addEventListener('click', function (e) {
          target.removeChild(backdrop)
          target.removeChild(messageMediaImg)
          target.removeAttribute('style')
          target.removeAttribute(closeImg)
        }, false)
      },
      reuse: function (e) {
        let self = this
        let mediaId = e.target.dataset.mediaId
        let currentMedia = this.$parent.getMedia(mediaId)
        let messagedefinition = this.definitions.templates.find(function (item) {
          return item.templateId === currentMedia.media_content.type_annonce
        })
        let Message = AppModules.getMessage(messagedefinition, null)
        //
        console.log('messagedefinition.imageInput.shouldCheck')
        console.log(messagedefinition)
        if (currentMedia.media_content.titre) {
          messagedefinition.fullStyle.title.html = currentMedia.media_content.titre
        }
        if (currentMedia.media_content.texte) {
          console.log('//////////////////////\n-currentMedia.media_content.texte')
          console.log(currentMedia.media_content.texte)
          messagedefinition.fullStyle.mainText.html = currentMedia.media_content.texte
          messagedefinition.reducedStyle.mainText.html = Message.reuseMainTextHtml(currentMedia.media_content.texte)
          console.log('//////////////////////\n-messagedefinition.reducedStyle.mainText.html')
          console.log(messagedefinition.reducedStyle.mainText.html)
        }
        if (currentMedia.media_content.visuel) {
          Message.getBase64Media(this.$parent.userProps, currentMedia, function (err, base64Media) {
            if (err) {
              console.log(err)
            }
            console.log('////////////////////////////////\n-updatedMedia')
            if (base64Media) {
              messagedefinition.fullStyle.imageInput.content = base64Media
              messagedefinition.reducedStyle.imageInputPlaceholderHTML = '<br/>'
            }
            AppModules.clearMessages()
            Message.storeReuseableMessage(self.$router)
          })
        } else if (!messagedefinition.fullStyle.imageInput.shouldCheck) {
          AppModules.clearMessages()
          Message.storeReuseableMessage(self.$router)
        }
      }
    }
  }
</script>

<style scoped>
  /* - - - - - - - - - - - */

  .context-ico {
    float: right;
    font-size: 14px;
    font-weight: normal;
  }

  .bmtv-tooltip.top .bmtv-tooltip-arrow {
    bottom: 20px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px 5px 0;
    border-top-color: var(--grey-eighth-color);
  }

  .bmtv-tooltip-inner {
    padding: 3px 0;
    color: var(--secondary-color);
    text-align: center;
    background-color: var(--grey-eighth-color);
    border-radius: 4px;
    box-shadow: 0 2px 5px 0.2px rgba(0, 0, 0, 0.25);
  }

  .bmtv-tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    box-sizing: border-box;
  }

  .bmtv-tooltip.top {
    padding: 5px 0;
    position: absolute;
  }

  .bmtv-tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    font-family: 'Open Sans', Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    white-space: normal;
    line-break: auto;
    z-index: 999;
  }

  .bmtv-tooltip-left {
    min-width: 150px;
    height: 120px;
    right: calc(100vh / (1080 / 100));
    transform: skew(-5deg);
  }

  .bmtv-tooltip-right {
    min-width: 150px;
    height: 120px;
    left: calc(100vh / (1080 / 100));
    transform: skew(5deg);
  }

  .bmtv-tooltip-inner-item {
    letter-spacing: 0.4px;
    padding: 2px 8px;
    text-align: left;
    font-weight: normal;
    background-color: none;
    cursor: pointer;
  }

  .bmtv-tooltip-inner-item:hover {
    letter-spacing: 0;
    font-weight: bold;
    background-color: var(--grey-third-color);
  }

  .terminal-left-single {
    background-position: 8px 0;
    background-repeat: no-repeat;
    width: calc(100vw / (1920 / 360));
    height: calc(100vw / (1920 / 251));
    display: inline-block;
    position: relative;
  }

  .terminal-left, .terminal-right {
    background-position: 0 4px;
    background-repeat: no-repeat;
    width: calc(100vw / (1920 / 448));
    height: calc(100vw / (1920 / 320));
    display: inline-block;
    position: relative;
  }

  .terminal-left-single {
    background-image: url(/static/images/terminal-left-single.svg);
  }

  .terminal-left {
    background-image: url(/static/images/terminal-left.svg);
  }

  .terminal-right {
    background-image: url(/static/images/terminal-right.svg);
    margin-left: calc(100vw / (1920 / 132));
  }

  .slot-number-left, .slot-number-right {
    position: absolute;
    box-sizing: border-box;
    width: calc(100vw / (1920 / 119));
    height: calc(100vw / (1920 / 119));
    bottom: calc(100vw / (1920 / 17));
  }

  .slot-number-left span, .slot-number-right span {
    width: calc(100vw / (1920 / 119));
    height: calc(100vw / (1920 / 119));
    font-family: 'Open Sans', Arial;
    font-weight: 600;
    color: var(--primary-color);
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  .slot-number-left {
    left: 0;
  }

  .slot-number-right {
    right: 0;
  }

  .terminal-monitor-left, .terminal-monitor-right {
    position: absolute;
    border: calc(100vw / (1920 / 7)) solid var(--grey-eighth-color);
    border-radius: calc(100vw / (1920 / 20));
    box-sizing: content-box;
    height: calc(100vw / (1920 / 172));
    width: calc(100vw / (1920 / 275));
  }

  .terminal-monitor-left {
    transform: skew(5deg);
    right: calc(100vw / (1920 / 3));
  }

  .terminal-monitor-right {
    transform: skew(-5deg);
    left: calc(100vw / (1920 / 3));
  }

  .terminal-monitor-left-img, .terminal-monitor-right-img {
    position: relative;
    border-radius: calc(100vw / (1920 / 14));
    box-sizing: content-box;
    height: calc(100vw / (1920 / 172));
    width: calc(100vw / (1920 / 275));
  }

</style>


// WEBPACK FOOTER //
// CurrentDiffusion.vue?27ea0102